module.exports = __webpack_public_path__ + "static/media/banner-01.beb0e774.png";